import { useEffect, useMemo, useRef, useState } from "react";
import {
  WEIGHING_AVG_FILTER_ABOVE_OPTIONS,
  WEIGHING_AVG_FILTER_BELOW_OPTIONS,
  WEIGHING_AVG_FILTER_OPTIONS,
} from "../utils/constants";

function FilterGroup({ title, options, selected, onToggle }) {
  return (
    <div className="avg-filter__group">
      <div className="avg-filter__heading">{title}</div>
      {options.map((option) => (
        <label key={option.value} className="avg-filter__option">
          <input
            type="checkbox"
            checked={selected.includes(option.value)}
            onChange={() => onToggle(option.value)}
          />
          <span>{option.label}</span>
        </label>
      ))}
    </div>
  );
}

export default function AvgHighlightFilter({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const selected = value ?? [];

  useEffect(() => {
    function handleOutsideClick(event) {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const triggerLabel = useMemo(() => {
    if (!selected.length) return "Ortalama vurgu";
    if (selected.length === 1) {
      return WEIGHING_AVG_FILTER_OPTIONS.find((item) => item.value === selected[0])?.label ?? "1 filtre";
    }
    return `Ortalama vurgu (${selected.length})`;
  }, [selected]);

  function toggleOption(optionValue) {
    onChange(
      selected.includes(optionValue)
        ? selected.filter((item) => item !== optionValue)
        : [...selected, optionValue]
    );
  }

  return (
    <div className="avg-filter" ref={rootRef}>
      <button
        type="button"
        className={`avg-filter__trigger${open ? " is-open" : ""}${selected.length ? " has-selection" : ""}`}
        onClick={() => setOpen((prev) => !prev)}
        title="Ortalama altı/üstü hücre vurgusu — çoklu seçim"
        aria-label="Ortalama vurgu filtresi"
        aria-expanded={open}
      >
        <span className="avg-filter__trigger-label">{triggerLabel}</span>
        <span className="avg-filter__trigger-caret" aria-hidden>▾</span>
      </button>

      {open && (
        <div className="avg-filter__panel">
          <FilterGroup
            title="Ortalamanın altında"
            options={WEIGHING_AVG_FILTER_BELOW_OPTIONS}
            selected={selected}
            onToggle={toggleOption}
          />
          <FilterGroup
            title="Ortalamanın üstünde"
            options={WEIGHING_AVG_FILTER_ABOVE_OPTIONS}
            selected={selected}
            onToggle={toggleOption}
          />
          {selected.length > 0 && (
            <button
              type="button"
              className="avg-filter__clear"
              onClick={() => onChange([])}
            >
              Seçimi temizle
            </button>
          )}
        </div>
      )}
    </div>
  );
}
